import { Inject } from '@odinjs/odin';
import { ModalService, TextAreaAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel } from '@philips-internal/oswald-ui-core/lib/client';
import { DialogType, ModalType, SimpleDialogParams } from '../../../interfaces/simple-dialog';

import { FragmentNames } from '../../../codegen';
import { IntakesAndOutputsRetroactiveJustificationAliases } from '../../../codegen/constants/aliases/intakes-and-outputs-retroactive-justification-aliases';
import BaseController from '../../BaseController';
import { SimpleDialog } from '../../dialog-helper';

@Controller({ fragment: FragmentNames.INTAKES_AND_OUTPUTS_RETROACTIVE_JUSTIFICATION })
class IntakesAndOutputsRetroactiveJustificationController extends BaseController {

  @Inject(IntakesAndOutputsRetroactiveJustificationAliases.TEXT_AREA_INTAKES_RETROACTIVE_JUSTIFICATION)
  justificationTextAreaApi!: TextAreaAPI;

  showMessageDialog(title: string, description: string): void {
    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: description,
      dialogType: DialogType.ALERT,
      modalType: ModalType.DIALOG,
      onClickOk: (): void => ModalService.close(FragmentNames.INTAKES_AND_OUTPUTS_RETROACTIVE_JUSTIFICATION),
      titleDialog: title,
      titleOnOk: 'OK',
    }
    SimpleDialog.openDialog(dialogParams);
  }

  @OnCancel({ target: IntakesAndOutputsRetroactiveJustificationAliases.FORM_INTAKES_RETROACTIVE_JUSTIFICATION })
  onCancelForm(): void {
    ModalService.close(FragmentNames.INTAKES_AND_OUTPUTS_INACTIVATE);
  }

  @OnBeforeSubmit({ target: IntakesAndOutputsRetroactiveJustificationAliases.FORM_INTAKES_RETROACTIVE_JUSTIFICATION })
  onBeforeSubmitForm(): void {
    ModalService.close(FragmentNames.INTAKES_AND_OUTPUTS_RETROACTIVE_JUSTIFICATION);
  }
}

export default IntakesAndOutputsRetroactiveJustificationController;